/**
 * Context + types for `ChangeRequestConfirmProvider`. Split from the
 * provider component so the file can be imported by hooks without
 * tripping `react-refresh/only-export-components`.
 */
import { createContext, useContext } from 'react';

export interface ChangeRequestConfirmation {
  requesterComment: string;
}

export interface ChangeRequestConfirmContextValue {
  /**
   * Open the confirm modal. Resolves with `{ requesterComment }` if the
   * user confirms, or `null` if they cancel / dismiss. Only one prompt can
   * be active at a time — a second call while one is open settles the
   * previous prompt as cancelled (defensive against double-fire from
   * stacked mutation retries).
   */
  requestConfirmation: () => Promise<ChangeRequestConfirmation | null>;
}

export const ChangeRequestConfirmContext =
  createContext<ChangeRequestConfirmContextValue | null>(null);

export const useChangeRequestConfirm = (): ChangeRequestConfirmContextValue => {
  const ctx = useContext(ChangeRequestConfirmContext);
  if (!ctx) {
    throw new Error(
      'useChangeRequestConfirm must be used within ChangeRequestConfirmProvider'
    );
  }

  return ctx;
};
